import Vue from 'vue';
import { socketStream } from '../../model/socket-stream.js';
import { tradingSettings } from '../../model/trading-settings.js';

export default {
	namespaced: true,
	state: {
		quotes: {}
	},
	mutations: {
		setQuotes(state, data) {
			for (let i = 0; i < data.length; i++) {
				data[i].sign = deriveSign(state.quotes[data[i].name], data[i]);
                data[i].point = derivePoint(state.quotes[data[i].name], data[i].bid);
                data[i].percent = derivePercent(state.quotes[data[i].name], data[i].bid);
                Vue.set(state.quotes, data[i].name, data[i]);
				//state.quotes[data[i].name] = data[i];
			}
		}
	},
	getters: {
		getQuotes(state) {
			return state.quotes;
		},
		getFilteredQuotes(state) {
			return (filterHash) => {
				let filtered = {};
				for (let symbol in state.quotes)
					if (filterHash[symbol])
						filtered[symbol] = state.quotes[symbol];
				return filtered;
			}
		}
	},
	actions: {
		updateQuotes(state, data) {
			state.commit('setQuotes', data);
		},
		subscribe(state) {
			// handle quotes message
			socketStream.addChannelHandler('Quote', 'quotestor', (quotes) => {
				// ["BTCUSD", 7393.12, 7487.57, "MBTUSD", 6.997, 7.088, "MBTUSDd", 6.997, 7.088, "BTCEUR", 6057.54, 6114.09]
				let count = Math.floor(quotes.length / 3);
				let objects = [];
				for (let i = 0; i < count; i++) {
					objects.push({
						name: quotes[i * 3],
						bid: quotes[i * 3 + 1],
						ask: quotes[i * 3 + 2],
                        prec: derivePrecision(quotes[i * 3 + 1]),
					});
                }
				// leave main quotes only
                objects = objects.filter(q => tradingSettings.isMainTicker(q.name));
				state.commit('setQuotes', objects);
			});

			// subscribe
			let subMsg = JSON.stringify({
				ClassName: "QuoteSubscription",
				SubscribeOnAll: false,
				Quotes: tradingSettings.getMainContracts()
			});
			socketStream.subscribeOnConnect(() => {
				socketStream.socket.send(subMsg);
			});			
		}
	}
}

function derivePrecision(p) {
	return p > 100000 ? 0 : p > 1000 ? 1 : p > 250 ? 2 : p > 75 ? 3 : p > 10 ? 4 : p > 0.25 ? 5 : p > 0.25 ? 6 : 7;
}

function deriveSign(oldQ, newQ) {
	if (!oldQ) return 0;
	return newQ.bid > oldQ.bid ? 1 : newQ.bid < oldQ.bid ? -1 : newQ.ask > oldQ.ask ? 1 : newQ.ask < oldQ.ask ? -1 : 0;
}
function derivePoint (oldQ, newQ) {
    if (!oldQ) return 0;
    return (newQ - oldQ.bid).toFixed(5);
}
function derivePercent (oldQ, newQ) {
    if (!oldQ) return 0;
    let percent = (100/(oldQ.bid/newQ)) - 100; 
   return percent.toFixed(5);
}